import { IDoctors } from "@alpha/types";
import { Component, ChangeDetectionStrategy, OnInit, TemplateRef, ViewChild, ChangeDetectorRef } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { ColumnDefinition, ColumnTemplateType } from "app-core";
import { ReferralService } from "app-service";
import { map, Subject, takeUntil } from "rxjs";

@Component({
  selector: 'app-manage-referral',
  templateUrl: './manage-referral.component.html',
  styleUrls: ['./manage-referral.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ReferralService]
})
export class ManageReferralsComponent implements OnInit {
  @ViewChild('statusColumn', { static: true }) public statusColumn?: TemplateRef<any>;
  public userList: any[] = [];
  public dataSource = new MatTableDataSource(this.userList);
  public displayedColumns: Array<ColumnDefinition> = [];
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  public constructor(
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _referralService: ReferralService
  ) { }

  public ngOnInit(): void {
    this.getDisplayedColumns();
    this.getDoctorsListWithReferral();
  }

  private getDisplayedColumns(): void {
    this.displayedColumns = [
      {
        id: 'UserName',
        displayName: 'User Name',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 25
      },
      {
        id: 'Contact',
        displayName: 'Contact',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 20
      },
      {
        id: 'Status',
        displayName: 'Status',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 20
      },
      {
        id: 'PaymentStatus',
        displayName: 'Payment Status',
        templateType: ColumnTemplateType.Text,
        requestedWidth: 20
      },
    ];
  }

  private getDoctorsListWithReferral(): void {
    this._referralService.getDoctorsListWithReferral()
      .pipe(
        map((doctorsList: Array<Partial<IDoctors>>) => {
          let responseObj: any[] = [];

          if (doctorsList.length > 0) {
            doctorsList.forEach((doctor: any, index: number) => {
              responseObj.push({
                '_id': doctor._id,
                'UserName': `${doctor.firstName} ${doctor.lastName}`,
                'Contact': `${doctor.contact}`,
                'Status': `${doctor.subscribed ? 'Subscribed' : 'Not Subscribed'}`,
                'PaymentStatus': `${doctor.transaction && doctor.transaction.completed ? 'Completed' : 'Not Completed'}`
              });
            });
          }

          return responseObj;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        (response) => {
          this.userList = response;
          this.dataSource = new MatTableDataSource(this.userList);
          this._cdRef.markForCheck();
        }
      );
  }
}
